// 意见反馈管理
export default [
  {
    path: "/opinion",
    meta: { title: "意见反馈管理" },
    component: () => import("../views/opinion/index.vue"),
    children: [
      {
        path: "/opinion/list",
        name: "opinionLlist",
        meta: { title: "意见反馈列表", isMenu: true },
        component: () => import("../views/opinion/list.vue"),
      },
    ],
  },
]
